<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';
import { computed } from 'vue';
import type { LegalFooterProps } from './legal-footer';

const props = withDefaults(defineProps<LegalFooterProps>(), {
  opensInNewTab: false,
});

const target = computed((): '_blank' | undefined =>
  props.opensInNewTab ? '_blank' : undefined,
);
</script>

<template>
  <span
    class="flex flex-wrap items-center justify-center gap-1 text-xs text-neutral-500 sm:space-x-4"
  >
    <a href="/legal/imprint/" :target="target" class="hover:underline">{{
      $t('navigation.imprint')
    }}</a>
    <a href="/legal/privacy/" :target="target" class="hover:underline">{{
      $t('navigation.privacy')
    }}</a>
    <a href="/legal/terms/" :target="target" class="hover:underline">{{
      $t('navigation.terms')
    }}</a>
    <!-- No referrer: the address of a code step can hold a login or reset code. -->
    <a
      href="https://status.teachino.io/"
      target="_blank"
      rel="noopener noreferrer"
      class="hover:underline"
      >{{ $t('navigation.status') }}</a
    >
    <span> &copy; Teachino FlexCo </span>
  </span>
</template>
